import { createContext, useReducer } from "react"
import ParamsReducer from "./ParamsReducer";

const PARAMS_INITIAL_STATE = {
    awsparams:  null,
    paramsIsFetching: false,
    paramsError: false
}

export const ParamsContext = createContext(PARAMS_INITIAL_STATE);

export const ParamsContextProvider = ({ children }) => {
    const [paramstate, paramsdispatch] = useReducer(ParamsReducer, PARAMS_INITIAL_STATE);

    return <ParamsContext.Provider value={{
        awsparams: paramstate.awsparams,
        paramsIsFetching: paramstate.paramsIsFetching,
        paramsError: paramstate.paramsError,
        paramsdispatch
    }}>{children}</ParamsContext.Provider>

}